import { axiosConfig } from '../api/axios-config.js'

export const aiSettings = {
  /**
   * 取得 AI 設定列表
   */
  get: (params, token) => axiosConfig.get('/api/ai/settings', token, params),

  /**
   * 取得單一設定
   */
  getOne: (id, token) => axiosConfig.get(`/api/ai/settings/${id}`, token),

  /**
   * 建立新設定
   */
  create: (data, token) => axiosConfig.post('/api/ai/settings', data, token),

  /**
   * 更新設定
   */
  update: (id, data, token) => axiosConfig.put(`/api/ai/settings/${id}`, data, token),

  /**
   * 刪除設定
   */
  delete: (id, token) => axiosConfig.delete(`/api/ai/settings/${id}`, token),

  /**
   * 測試 AI 設定
   */
  test: (id, data, token) => axiosConfig.post(`/api/ai/settings/${id}/test`, data, token),

  /**
   * 複製設定
   */
  duplicate: (id, data, token) => axiosConfig.post(`/api/ai/settings/${id}/duplicate`, data, token),

  /**
   * 取得統計資料
   */
  getStatistics: (id, token) => axiosConfig.get(`/api/ai/settings/${id}/statistics`, token),

  /**
   * 重設統計
   */
  resetStatistics: (id, token) => axiosConfig.post(`/api/ai/settings/${id}/reset-statistics`, {}, token),

  /**
   * 驗證 API Key
   */
  validateApiKey: (data, token) => axiosConfig.post('/api/ai/settings/validate-api-key', data, token)
}